import { Badge } from '@/components/ui/badge';

interface PeriodStatusPillProps {
  startDate: string;
  endDate: string;
}

export function PeriodStatusPill({
  startDate,
  endDate,
}: PeriodStatusPillProps) {
  const todayString = new Date().toISOString().split('T')[0]; // Get YYYY-MM-DD format

  const isActive = startDate <= todayString && endDate >= todayString;
  const isUpcoming = startDate > todayString;

  if (isUpcoming) {
    return (
      <Badge
        variant="secondary"
        className="bg-blue-100 text-blue-800 hover:bg-blue-100"
      >
        Upcoming
      </Badge>
    );
  }

  return (
    <Badge
      variant={isActive ? 'default' : 'destructive'}
      className={
        isActive
          ? 'bg-green-100 text-green-800 hover:bg-green-100'
          : 'bg-red-100 text-red-800 hover:bg-red-100'
      }
    >
      {isActive ? 'Active' : 'Expired'}
    </Badge>
  );
}
